import { BREAKPOINT } from '@constants/breakpoints'
import { useBreakpoint } from '@hooks/useBreakpoint'
import { SurfaceLevel } from '@ui-kit/types/surface'
import { FC } from 'react'

import { Modal, ModalProps } from '../Modal'
import { SideModal } from './SideModal'

export interface SideModalProps
  extends Omit<ModalProps, 'isCentered' | 'size' | 'level'> {
  surface?: SurfaceLevel
}

interface SideModalResponsiveWrapperProps extends ModalProps, SideModalProps {}

export const SideModalResponsiveWrapper: FC<
  SideModalResponsiveWrapperProps
> = ({ children, className = '', onClose, surface = 1, ...restProps }) => {
  const shouldUseDefaultModal = useBreakpoint(BREAKPOINT[720], 'max')

  if (shouldUseDefaultModal) {
    return (
      <Modal className={className} onClose={onClose} {...restProps}>
        {children}
      </Modal>
    )
  }

  return (
    <SideModal
      className={className}
      onClose={onClose}
      surface={surface}
      {...restProps}
    >
      {children}
    </SideModal>
  )
}

SideModal.displayName = 'SideModal'
